<template>
  <header>
    <div class="brand">
      <img src="../../../assets/wb/wb_logo.png" alt="" />
      <span class="title">{{ data.text_1 }}</span>
    </div>
    <div class="options">
      <button class="nav">{{ data.text_2 }}</button>
      <button class="nav">{{ data.text_3 }}</button>
      <button class="nav">{{ data.text_4 }}</button>
      <button class="nav">{{ data.text_5 }}</button>
      <button class="nav">{{ data.text_6 }}</button>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    data: {
      text_1: "Academia",
      text_2: "What we do",
      text_3: "Why us",
      text_4: "Courses",
      text_5: "Testimonials",
      text_6: "FAQ",
    },
  },
};
</script>
<style>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 2.5rem;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.11);
  position: sticky;
  top: 0;
  z-index: 10;
}
header .brand {
  display: flex;
  align-items: center;
}
header .brand img {
  width: 50px;
  margin-right: 0.3rem;
}
header .options {
  cursor: default;
}
header .options button.login {
  padding: 0.4rem 2rem;
  border-radius: 5px;
  background-color: #ea3c49;
  transition: background-color 0.2s;
  color: #fff;
  border: none;
  font-size: 1rem;
  box-shadow: none;
}
header .options button.login:hover {
  background-color: #db333e;
  transition: background-color 0.2s;
}
header .options button.nav {
  background: none;
  border: none;
  font-size: 0.9rem;
  padding: 0;
  margin: 0rem 0.9rem;
  font-weight: 600;
}
header .brand .title {
  color: #ea3c49;
  font-family: "Volkhov", serif;
  font-size: 1.8rem;
  font-weight: 400;
}
</style>